import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendFormRequest,
  requestFinished,
  selectFieldToken,
  clearAllErrors,
  changeMessage
} from '../../../../common/reducers/forms/confirmForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';
import { sendGetAuthAccountDataRequest } from '../../../../common/reducers/states/authAccount';

function* confirmChangeEmailFormSaga(reducerName) {
  const tokenField = yield select(selectFieldToken, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(
      timeoutCall,
      UserService.confirmChangeEmail,
      tokenField.value
    );
    if (response) {
      yield put(changeMessage(reducerName, response.data.message));
      if (response.status === 200) {
        yield put(sendGetAuthAccountDataRequest());
      }
    }
    yield put(
      requestFinished(reducerName, response.status, response.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendFormRequest(reducerName).type,
      confirmChangeEmailFormSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/confirmChangeEmailFormSaga.js